/* eslint-disable array-callback-return */
import { useTranslation } from "react-i18next";
import React, { useEffect, useState } from "react";
import { connect, useDispatch, useSelector } from "react-redux";
import "../../../src/custom.css";
import toast, { Toaster, useToasterStore } from "react-hot-toast";
import { Tooltip, Breadcrumb } from "antd";
import Layout from "../Layout";
import Loader from "../loader";
import NotAuthorised from "../Authentication/NotAuthorised";
import Title from "../Title";
import { Link } from "react-router-dom/cjs/react-router-dom";
import layer from "../../assets/images/titleuser.svg";
import filepng from "../../assets/images/layer.svg";
import tiltedUser from "../../assets/images/filename.svg";

const TEKaLogErase = () => {
  const { t } = useTranslation("addCompany");
  const loggedInUserId = localStorage.getItem("UserId");
  const [roleId, setRoleId] = useState(null);
  const [loading, setLoading] = useState(false);

  return (
    <div>
      <Title title="Erase Logs" />

      <Layout>
        <section className="Company_section common">
          <Toaster />
          {/* {loading ? <Loader /> : ''}*/}
          <div className="container">
            <div className="heading-title d-flex align-items-lg-center gap-3 w-100 py-3 flex-column-reverse flex-lg-row">
              <h2 className="m-0 text-white">Erase TEKaLogs</h2>
              <Breadcrumb
                className="ml-lg-auto ml-0 p-0 mb-0 w-auto"
                itemRender={(route) =>
                  route.path ? (
                    <Link to={route.path}>{route.breadcrumbName}</Link>
                  ) : (
                    <span>{route.breadcrumbName}</span>
                  )
                }
                items={[
                  { breadcrumbName: "Dashboard", path: "/Dashboard" },
                  { breadcrumbName: "Support", path: "" },
                  { breadcrumbName: "Support Logs", path: "" },
                ]}
              />
            </div>

            <div className="w-full d-flex flex-wrap gap-4">
              <div className="form-group wk-select1">
                <select
                  className="form-select mb-0 flex-grow-1 filter-select"
                  aria-label=".form-select-lg example"
                  // showSearch
                  style={{ width: 250 }}
                  placeholder="Select User"
                >
                  <option selected="">Select User </option>
                </select>
              </div>

              <div className="retention-days">
              <img src={filepng}/>
                <div>
                  <strong>Retention Days</strong>
                  <h5>30</h5>
                </div>
              </div>

              <div className="form-group wk-select1">
                <select
                  className="form-select mb-0 flex-grow-1 filter-select"
                  aria-label=".form-select-lg example"
                  // showSearch
                  style={{ width: 250 }}
                  placeholder="Select User"
                >
                  <option selected="">Select User </option>
                </select>
              </div>
            </div>

            <div className="tekalog-dev">
               
              <div className="tekalog-container">
                <img src={layer}/>
                <div>
                  <h4>tekalog-dev-container</h4>
                  <span>Container</span>
                </div>
              </div>

              <div className="row">
                <div className="col-md-4 col-lg-3">
                  <div className="records ">
                    <div className="record-icons">
                    <img src={tiltedUser}/>
                    
                    </div>
                    <div className="record-text">
                      <h4>Total Records</h4>
                      <span>20</span>
                    </div>
                  </div>
                </div>

                <div className="col-md-4  col-lg-3">
                  <div className="records ">
                    <div className="record-icons">
                    <img src={filepng}/>
                    </div>
                    <div className="record-text">
                      <h4>Total Records</h4>
                      <span>30</span>
                    </div>
                  </div>
                </div>
                <div className="col-md-4 col-lg-6 text-right"> <button className="dlt-log">Delete Logs</button></div>
              </div>
            </div>
            <p className="text-right mt-1">Selected File : abc.txt</p>
          </div>
        </section>
      </Layout>
    </div>
  );
};

export default connect()(TEKaLogErase);
